import React, { useState } from "react";
import FilterField from "./FilterField";

/**
 * UserProfiles compact filter section: primary row + optional "More filters" expandable.
 * @param {Array} primaryFields - field configs: { name, label, type, placeholder?, options?, min?, max? }
 * @param {Array} [secondaryFields] - field configs for expandable section
 * @param {Object} values - key -> value
 * @param {function} onChange - (e) => {}
 * @param {function} onApply - () => {}
 * @param {function} onClear - () => {}
 * @param {string} [applyLabel]
 * @param {string} [clearLabel]
 * @param {boolean} [defaultExpanded]
 */
const FilterSection = ({
  primaryFields = [],
  secondaryFields = [],
  values,
  onChange,
  onApply,
  onClear,
  applyLabel = "Apply",
  clearLabel = "Clear",
  defaultExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const hasMore = secondaryFields?.length > 0;

  const renderFields = (fields) =>
    fields.map((config) => (
      <FilterField
        key={config.name}
        name={config.name}
        label={config.label}
        type={config.type || "text"}
        value={values[config.name]}
        onChange={onChange}
        placeholder={config.placeholder}
        options={config.options}
        min={config.min}
        max={config.max}
        compact
      />
    ));

  return (
    <div className="mb-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
        {renderFields(primaryFields)}
        <div className="col-span-2 sm:col-span-3 md:col-span-4 lg:col-span-5 xl:col-span-6 flex flex-wrap items-end gap-2">
          {hasMore && (
            <button
              type="button"
              onClick={() => setExpanded((e) => !e)}
              className="text-xs font-medium text-red-600 hover:text-red-700 py-1.5 px-3 rounded border border-red-200 hover:bg-red-50 transition-colors">
              {expanded ? "Less filters" : "More filters"}
            </button>
          )}
          <button
            type="button"
            onClick={onApply}
            className="bg-red-500 hover:bg-red-600 text-white font-medium py-1.5 px-4 rounded-md text-xs shadow-sm transition-colors">
            {applyLabel}
          </button>
          <button
            type="button"
            onClick={onClear}
            className="bg-white border border-gray-300 text-gray-700 font-medium py-1.5 px-4 rounded-md text-xs hover:bg-gray-50 transition-colors">
            {clearLabel}
          </button>
        </div>
      </div>

      {hasMore && expanded && (
        <div className="mt-3 pt-3 border-t border-gray-200 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {renderFields(secondaryFields)}
        </div>
      )}
    </div>
  );
};

export default FilterSection;
